import React from 'react';
import IconActionLink from 'components/IconActionLink';
import { EmptyStateProps } from '../props';

const EmptyState: React.FC<EmptyStateProps> = ({ text, title, href, onClick }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-6">
      <span className="typography-product-caption block text-center text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {text}
      </span>
      {title && (href || onClick) && (
        <IconActionLink title={title} href={href || ''} onClick={onClick} />
      )}
    </div>
  );
};

export default EmptyState;
